<template>
    <div class="account-content">
        <div v-if="method == 'cellphone'">
            <div class="row">
                <div class="col-xs-12 m-t-20">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('input')}">
                        <p class="text-mutted"><b>Preencha no campo abaixo o código de 6 caracteres recebido por SMS no celular {{ cellphone }}:</b></p>

                        <input id="input" type="text" v-model="form.code"
                            class="form-control"
                            name="code"
                            v-validate="'required'"
                            placeholder="Código recebido por sms"
                            required />

                        <span class="help-block text-left" v-show="errors.has('code')">
                            <strong>{{ errors.first('code') }}</strong>
                        </span>

                        <span class="help-block text-left text-danger" v-show="wrong_code">
                            <strong>Não conseguimos verificar o código. Verifique se o código preenchido está correto, e tente novamente!</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <button type="button" @click="verifySmsCode()" class="btn btn-success btn-block waves-effect waves-light m-t-20 ladda-button password-btn">
                        <span class="ladda-label">Confirmar Código</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="method == 'email'">
            <div class="row">
                <div class="col-xs-12">
                    <p><i class="far fa-check-circle text-success m-r-5"></i> <b>Enviamos para o email {{ email }} as instruções para que você recupere
                        a senha de sua conta no WebQuarto. Caso não localize nosso email na Caixa de Entrada
                        do seu email, por gentileza, verifique também na lista de emails enviados para spam.</b></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['method', 'cellphone', 'email', 'full_email'],
    data() {
        return {
            form: {
                code: '',
            },
            wrong_code: false,
        }
    },
    methods: {
        verifySmsCode() {
            this.wrong_code = false;
            this.$validator.validateAll().then(res => {
                if (!res)
                    return;

                let l = Ladda.create( this.$el.querySelector('.ladda-button') );
                l.start();

                axios.post('/auth/password/verify-token', {email: this.full_email, token: this.form.code}).then(res => {
                    if (res.data.msg == 'ok') {
                        this.$emit('verified', this.form.code);
                    } else {
                        this.wrong_code = true;
                    }
                }).finally(() => {
                    l.stop();
                });
            });
        }
    }
}
</script>
